import { AppMode } from '../types';

const NAV_EVENT = 'cobalt:navigate';

export const navigateTo = (mode: AppMode) => {
  window.dispatchEvent(new CustomEvent(NAV_EVENT, { detail: { mode } }));
};

export const onNavigate = (handler: (mode: AppMode) => void) => {
  const listener = (event: Event) => {
    const detail = (event as CustomEvent).detail;
    if (detail?.mode) handler(detail.mode as AppMode);
  };
  window.addEventListener(NAV_EVENT, listener);
  return () => window.removeEventListener(NAV_EVENT, listener);
};
